<script>
    import router from "page";
    import { onMount } from "svelte";
    import { isLoading, locale } from "../stores.js";

    import { TabulatorFull as Tabulator } from "tabulator-tables";

    import { getLocaleResource } from "../utils/locales.js";

    import {
        keywordFilter,
        dateFormatter,
        currencyFormatter,
    } from "../utils/utilsTabulator.js";

    import { fetchGet } from "../utils/utilsFetch.js";

    let data, table, tableElement;

    onMount(async () => {
        $isLoading = true;

        data = await fetchGet(`/api/finance`);


        table = new Tabulator(tableElement, {
            height: "100%",
            data: data,
            layout: "fitDataFill",
            vertAlign: "middle",
            columns: [
                {
                    title: getLocaleResource($locale, "date"),
                    field: "date",
                    formatter: dateFormatter,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "dueDate"),
                    field: "dateDue",
                    formatter: dateFormatter,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "document"),
                    field: "documentKey",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "debit"),
                    field: "debit",
                    formatter: currencyFormatter,
                    formatterParams: { currency: "KM" },
                },
                {
                    title: getLocaleResource($locale, "credit"),
                    field: "credit",
                    formatter: currencyFormatter,
                    formatterParams: { currency: "KM" },
                },
                {
                    title: getLocaleResource($locale, "balance"),
                    field: "balance",
                    formatter: currencyFormatter,
                    formatterParams: { currency: "KM" },
                },
            ],
        });

        table.on("rowClick", (e, row) => {
            let data = row._row.data;
            router(`/invoices/${data.documentKey}`);
        });

        $isLoading = false;
    });
</script>

<div class="container">
    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        padding: 10px;
        display: flex;
        height: 100%;
    }

    .content {
        width: 100%;
        overflow: auto;
    }

    .pic {
        margin-right: 10px;
    }

    .info {
        display: flex;
        flex-direction: column;
    }
</style>
